import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import ky from '@/services/api/httpService'
import filtersStore from '@/stores/FiltersStore.ts'
import { adaptFilter } from '@/utils/filters.ts'

const fireSymbol = {
  type: 'CIMPointSymbol',
  symbolLayers: [
    {
      type: 'CIMVectorMarker',
      enable: true,
      anchorPointUnits: 'Relative',
      dominantSizeAxis3D: 'Z',
      size: 15,
      billboardMode3D: 'FaceNearPlane',
      frame: {
        xmin: 0,
        ymin: 0,
        xmax: 300,
        ymax: 300
      },
      markerGraphics: [
        {
          type: 'CIMMarkerGraphic',
          geometry: {
            rings: [
              [
                [0, 150],
                [150, 0],
                [300, 150],
                [150, 300],
                [0, 150]
              ]
            ]
          },
          symbol: {
            type: 'CIMPolygonSymbol',
            symbolLayers: [
              {
                type: 'CIMSolidFill',
                enable: true,
                color: [0, 0, 0, 255],
                primitiveName: 'background'
              }
            ]
          }
        },
        {
          type: 'CIMMarkerGraphic',
          geometry: {},
          symbol: {
            type: 'CIMPolygonSymbol',
            symbolLayers: [
              {
                type: 'CIMSolidFill',
                enable: true,
                color: [255, 255, 255, 255],
                primitiveName: 'icon'
              }
            ]
          }
        },
        {
          type: 'CIMMarkerGraphic',
          geometry: {
            rings: [
              [
                [139.2, 52.5],
                [139.2, 53.1],
                [139.2, 60.9],
                [139.2, 65.3],
                [138.2, 67.1],
                [135.8, 67.6],
                [115.9, 67.6],
                [113.4, 67.7],
                [112.5, 69.4],
                [124.4, 90.1],
                [117.5, 90.5],
                [116.6, 92.1],
                [129.9, 115.4],
                [124.9, 115.9],
                [124.2, 117.2],
                [135.9, 137.6],
                [130, 138],
                [129.4, 139.1],
                [130.4, 141.1],
                [148, 170.3],
                [149.4, 171.4],
                [150.4, 171.6],
                [152.7, 170.3],
                [170.3, 141.1],
                [171.3, 139.1],
                [170.6, 138],
                [164.7, 137.6],
                [176.4, 117.2],
                [175.8, 115.9],
                [170.8, 115.4],
                [184.1, 92.1],
                [183.2, 90.5],
                [176.3, 90.1],
                [188.2, 69.3],
                [187.4, 67.7],
                [184.8, 67.6],
                [165, 67.6],
                [162.5, 67],
                [161.6, 65.2],
                [161.6, 60.3],
                [161.6, 53.1],
                [161.6, 52.7],
                [161.6, 48.2],
                [176.2, 48.2],
                [176.2, 55.1],
                [176.2, 58.8],
                [193.6, 67.6],
                [207.5, 79.9],
                [218, 95.8],
                [224.9, 115.1],
                [226.8, 128.8],
                [225.8, 142.2],
                [222, 155.8],
                [215.1, 169.9],
                [213.6, 153.8],
                [210.2, 142.2],
                [204.5, 133],
                [196.2, 125.9],
                [200.4, 145.6],
                [199.8, 166.3],
                [194.5, 187.5],
                [184.6, 208.3],
                [170, 228.2],
                [152.6, 244.3],
                [134.4, 254.6],
                [125.8, 257.1],
                [117.8, 257.8],
                [127, 246.6],
                [134.2, 234.7],
                [139.3, 222.4],
                [142, 210.2],
                [142.1, 198.5],
                [139.8, 187.8],
                [135, 178.6],
                [128, 171.1],
                [127.6, 185.3],
                [125.7, 196.2],
                [121.9, 205.6],
                [116, 213.7],
                [115.1, 199],
                [112.9, 189.5],
                [108.5, 180.8],
                [99.8, 168.5],
                [87.6, 151.1],
                [82.9, 141.5],
                [79.9, 131.5],
                [78.7, 121.2],
                [79.3, 111],
                [81.6, 101],
                [85.6, 91.6],
                [91.3, 82.9],
                [98.4, 75.2],
                [110.9, 65.5],
                [125, 58.3],
                [125, 55.1],
                [125.1, 48.2],
                [139.2, 48.2],
                [139.2, 52.5]
              ]
            ]
          },
          symbol: {
            type: 'CIMPolygonSymbol',
            symbolLayers: [
              {
                type: 'CIMSolidFill',
                enable: true,
                color: [255, 255, 255, 255],
                primitiveName: 'icon'
              }
            ]
          }
        },
        {
          type: 'CIMMarkerGraphic',
          geometry: {},
          symbol: {
            type: 'CIMPolygonSymbol',
            symbolLayers: [
              {
                type: 'CIMSolidFill',
                enable: true,
                color: [255, 255, 255, 255],
                primitiveName: 'icon'
              }
            ]
          }
        }
      ],
      scaleSymbolsProportionally: true,
      respectFrame: true,
      clippingPath: {
        type: 'CIMClippingPath',
        clippingType: 'Intersect',
        path: {
          rings: [
            [
              [0, 0],
              [300, 0],
              [300, 300],
              [0, 300],
              [0, 0]
            ]
          ]
        }
      }
    }
  ],
  haloSize: 1,
  scaleX: 1,
  angleAlignment: 'Display'
}

const colorOverride = {
  type: 'CIMPrimitiveOverride',
  primitiveName: 'background',
  propertyName: 'Color',
  valueExpressionInfo: {
    type: 'CIMExpressionInfo',
    title: 'color',
    expression: `return DefaultValue($feature.color, '#808080')`,
    returnType: 'Default'
  }
}

export default {
  id: 'incidents_layer',
  title: {
    'en-US': 'Incidents',
    'pt-BR': 'Incidentes',
    'es-ES': 'Incidentes',
    'fr-FR': 'Incidents'
  },
  icon: 'mdi-fire',
  type: 'geojson',
  active: true,
  customProperties: { group: 'reference' },
  zindex: 10,
  queryFields: ['id'],
  legend: {
    title: {
      'en-US': 'Incidents',
      'pt-BR': 'Incidentes',
      'es-ES': 'Incidentes',
      'fr-FR': 'Incidents'
    },
    items: [
      {
        text: {
          'en-US': 'Low',
          'es-ES': 'Bajo',
          'pt-BR': 'Baixo',
          'fr-FR': 'Bas'
        },
        color: '#60a5cf',
        icon: 'mdi-fire-circle'
      },
      {
        text: {
          'en-US': 'Moderate',
          'es-ES': 'Moderado',
          'pt-BR': 'Moderado',
          'fr-FR': 'Modéré'
        },
        color: '#b7e3bd',
        icon: 'mdi-fire-circle'
      },
      {
        text: {
          'en-US': 'High',
          'es-ES': 'Alto',
          'pt-BR': 'Alto',
          'fr-FR': 'Élevé'
        },
        color: '#f3fdcf',
        icon: 'mdi-fire-circle'
      },
      {
        text: {
          'en-US': 'Very High',
          'es-ES': 'Muy Alto',
          'pt-BR': 'Muito Alto',
          'fr-FR': 'Très élevé'
        },
        color: '#f1c08b',
        icon: 'mdi-fire-circle'
      },
      {
        text: {
          'en-US': 'Severe',
          'es-ES': 'Severo',
          'pt-BR': 'Severo',
          'fr-FR': 'Sévère'
        },
        color: '#d57080',
        icon: 'mdi-fire-circle'
      }
    ]
  },
  renderer: {
    type: 'unique-value',
    field: 'complexityId',
    defaultSymbol: {
      type: 'cim',
      data: {
        type: 'CIMSymbolReference',
        symbol: fireSymbol,
        primitiveOverrides: [colorOverride]
      }
    },
    visualVariables: [
      {
        type: 'size',
        field: 'size',
        stops: [
          { value: 1, size: 13 },
          { value: 10, size: 22 }
        ]
      }
    ]
  },
  // TODO: update with new timeout parameter when is available
  data: async () => {
    const { filters, searchText } = filtersStore()
    const filtersApplied = filters.map(adaptFilter).filter((filter) => filter)
    let url = 'api/incident/geojson'
    if (searchText) url += `?search=${searchText}`
    // Karonte >=0.16's ArcgisGeojsonLayer requires this to resolve to the raw response text,
    // which it JSON.parses itself (see ArcgisGeojsonLayer#getFeatureCollectionFromRawData);
    // 0.10 silently tolerated an already-parsed object as a fallback, 0.16 throws instead.
    return ky
      .post(url, {
        body: filtersApplied ? JSON.stringify(filtersApplied) : null,
        headers: {
          'Content-Type': 'application/json'
        },
        timeout: 120000
      })
      .text()
  }
} as LayerRaw
